import { faCompass } from '@fortawesome/pro-solid-svg-icons';

import { useTranslate } from '@growtherapy/i18n';

import { ControlPanelButton, ControlPanelButtonTooltip } from '../../components/ControlPanelButton';
import { DrawerButton } from '../../components/DrawerButton';
import { IconMenuItem } from '../../components/IconMenuItem';
import { VisitorDrawerState } from '../state';

export type IntentionsDrawerControlsProps = {
  className?: string;
  drawerId: string;
  isDrawerOpen: boolean;
  onClick: () => void;
  tooltipText: string;
};

export function IntentionsDrawerControls({
  className,
  drawerId,
  isDrawerOpen,
  onClick,
  tooltipText,
}: IntentionsDrawerControlsProps) {
  return (
    <div className={className}>
      <ControlPanelButtonTooltip childIsInteractive text={tooltipText}>
        <DrawerButton
          forDrawerStates={VisitorDrawerState.INTENTIONS}
          aria-label={tooltipText}
          aria-expanded={isDrawerOpen}
          aria-controls={drawerId}
          iconDefinition={faCompass}
          as={ControlPanelButton}
          onClick={onClick}
        />
      </ControlPanelButtonTooltip>
    </div>
  );
}

export type IntentionsDrawerControlMenuItemProps = {
  className?: string;
  drawerId: string;
  helperText: string;
  isDrawerOpen: boolean;
  onClick: () => void;
};

export function IntentionsDrawerControlMenuItem({
  className,
  drawerId,
  helperText,
  isDrawerOpen,
  onClick,
}: IntentionsDrawerControlMenuItemProps) {
  const t = useTranslate();
  return (
    <IconMenuItem
      aria-controls={drawerId}
      aria-expanded={isDrawerOpen}
      onClick={onClick}
      className={className}
      icon={faCompass}
    >
      <span className='sr-only'>{helperText}</span>
      <span aria-hidden>{t('telehealth-core:controls.intentions')}</span>
    </IconMenuItem>
  );
}
